import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(site)/client-layout.tsx");
